import React, { Component, Fragment } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";

import { makeStyles } from "@material-ui/core/styles";
// import CustomerEditModel from "./CustomerEditModel";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
//import CarouselMain from "./CarouselMain";
import {
  create_order_vedor_side,
  razor_pay_create_order,
  razor_payment,
  credit_memo_substitute_item,
  substitute_items,
  debit_memo_order_substitute_item,
  edit_location,
  editTransaction,
  edit_order_vendor_side_payment,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import store from "../../../../store/store";
import Alert from "react-s-alert";
import { CLEAR_CART_DATA } from "../../../../store/types";
import { ORDER_RAZORPAY_KEY } from "../../../../config/Keys";
import { getPendingPayment } from "../../../../function/getPendingPayment";
import { calcFinalTotalEdit, calcTotalOriginalEdit } from "../../../../function/ordering";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

class RightSideDetailsComponents extends Component {
  state = {
    tip: 0,
    open: false,
    openTract: false,
    total_amount: 0,
    total_charges: 0,
    open_memo_modal: false,
    create_memo: false,
  };

  setOpenTract = () => {
    this.setState({ open: false, openTract: true });
  };

  // prepareAddOn = (item) => {

  // };

  calcCharges = (data) => {
    let charges = 0;
    for (let i = 0; i < data.length; i++) {
      charges = data[i][0].charges * data[i][0].quantity + charges;
    }

    //  this.setState({ total_charges: charges.toFixed(2) });
    return charges.toFixed(2);
  };

  calcTotal = (data) => {
    let price = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
    }
    //this.setState({ total_amount: price.toFixed(2) });

    return parseFloat(price).toFixed(2);
  };

  calcFinalTotal = () => {
    let newItemAmount = 0;
    let oldItemAmount = 0;
    let finalTotalValue = 0;
    newItemAmount = parseFloat(
      this.calcSubstituteSurCharges(this.props.item && this.props.item[0]) -
      Math.abs(this.calculateExitingSurCharges(this.props?.user_data?.order_items)) +
      this.props?.user_data?.editItemPrice + newItemAmount
    ).toFixed(2);

    oldItemAmount = getPendingPayment(this.props.user_data) ? getPendingPayment(this.props.user_data).toFixed(2)
      : 0 + oldItemAmount;

    finalTotalValue = parseFloat(newItemAmount) + parseFloat(oldItemAmount);

    return finalTotalValue.toFixed(2);
  };

  calcAllCharges = (data) => {
    let itemPrice = 0;
    let addOns = 0;

    itemPrice = data.size.price * data.quantity;

    for (let i = 0; i < data.addOns.length; i++) {
      for (let j = 0; j < data.addOns[i].options.length; j++) {
        addOns =
          addOns + parseInt(data.addOns[i].options[j].price) * data.quantity;
      }
    }

    return itemPrice + addOns;
  };

  // calcSubsTotalIncludingAddon = (data) => {
  //   let itemPrice = 0;
  //   let addOns = 0;

  //   for (let i = 0; i < data.length; i++) {
  //     itemPrice += parseInt(data[i].size.price) * data[i].quantity;
  //     for (let j = 0; j < data[i].addOns.length; j++) {
  //       for (let k = 0; k < data[i].addOns[j].options.length; k++) {
  //         addOns +=
  //           parseInt(data[i].addOns[j].options[k].price) * data[i].quantity;
  //       }
  //     }
  //   }

  //   return parseFloat(itemPrice + addOns).toFixed(2);
  // };



  getDiscountPrice = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    let discountValues = [];
    for (let i = 0; i < data.length; i++) {
      price = parseFloat(this.calcAllCharges(data[i])) + price;
      itemPrice.push(parseFloat(this.calcAllCharges(data[i])));
    }
    if (this.props.user_data?.discount?.amount) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV, 0);
      itemPrice.forEach((e) => {
        percent.push((e / totalPrice) * 100);
      });
      discount = this.props?.user_data?.discount?.amount;
      price = totalPrice - discount;
      percent.forEach((e) => {
        discountValues.push(parseFloat(parseFloat((discount * e) / 100)));
      });
      discountValues = discountValues.map((e, i) => itemPrice[i] - e);
    } else {
      discountValues = itemPrice;
    }
    return discountValues;
  };

  calcSubstituteSurCharges = (data) => {
    let surCharges = 0;
    //let itemTotalIncludingAddon = this.calcAllCharges(data);

    for (let i = 0; i < data.length; i++) {
      let actualPrice = 0;
      actualPrice += parseInt(data[i].size.price) * data[i].quantity;
      for (let j = 0; j < data[i].addOns.length; j++) {
        for (let k = 0; k < data[i].addOns[j].options.length; k++) {
          actualPrice +=
            parseInt(data[i].addOns[j].options[k].price) * data[i].quantity;
        }
      }
      for (let m = 0; m < data[i].sur_charges.length; m++) {
        if (data[i].sur_charges[m].flag === "VALUE") {
          surCharges = surCharges + parseFloat(data[i].sur_charges[m].value);
        } else {
          let calcPercentage =
            (actualPrice * parseFloat(data[i].sur_charges[m].value)) / 100;
          surCharges = surCharges + calcPercentage;
        }
      }
    }
    return surCharges.toFixed(2);
  };

  calculateExitingSurCharges = (data) => {
    let exitingSurCharges = 0;
    //let itemTotalIncludingAddon = this.calcAllCharges(data);

    for (let i = 0; i < data.length; i++) {
      let actualPrice = 0;
      actualPrice += parseInt(data[i].size.price) * data[i].quantity;
      for (let j = 0; j < data[i].addOns.length; j++) {
        for (let k = 0; k < data[i].addOns[j].options.length; k++) {
          actualPrice +=
            parseInt(data[i].addOns[j].options[k].price) * data[i].quantity;
        }
      }
      for (let m = 0; m < data[i].sur_charges.length; m++) {
        if (data[i].sur_charges[m].flag === "VALUE") {
          exitingSurCharges =
            exitingSurCharges + parseFloat(data[i].sur_charges[m].value);
        } else {
          let calcPercentage =
            (actualPrice * parseFloat(data[i].sur_charges[m].value)) / 100;
          exitingSurCharges = exitingSurCharges + calcPercentage;
        }
      }
    }
    return exitingSurCharges.toFixed(2);
  };

  // calcSubstituteTotal = (data) => {
  //   let total = this.calcSubsTotalIncludingAddon(data);
  //   let charges = this.calcSubstituteSurCharges(data);
  //   let finalSubTotal = parseFloat(total) + parseFloat(charges);

  //   return parseFloat(finalSubTotal).toFixed(2);
  // };

  // calcSettleMentValue = (subsData, cartData) => {
  //   let cartprice = this.this.calcFinalTotal(cartData);
  //   let subPrice = this.calcSubstituteTotal(subsData);
  //   return parseFloat(
  //     parseFloat(cartprice).toFixed(2) - parseFloat(subPrice).toFixed(2)
  //   ).toFixed(2);
  // };

  onSuccess = () => {
    this.props.history.push("/orderdashboard");
  };

  loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  callDebitMemo = (amount) => {
    const formData = {};
    formData.amount = amount * -1;
    formData.order_id = this.props.substitute_existing_record.order_id;
    formData.items = [];
    let subsData = [...this.props.item];

    for (let i = 0; i < subsData.length; i++) {
      subsData[i].isSubstituted = true;
      formData.items.push(subsData[i]);
    }
    for (let i = 0; i < this.props.cart_data.length; i++) {
      formData.items.push(this.props.cart_data[i][0]);
    }
    if (this.props.substitute_existing_record.payment_status === 1) {
      const token = this.props.auth.user.accessToken;
      this.props.debit_memo_order_substitute_item(
        token,
        formData,
        this.onSuccessCallItemSubstitute
      );
    } else {
      this.onSuccessCallItemSubstitute();
    }
  };
  decidePayment = (payment) => {
    this.setState({ create_memo: true });
    let newAmount = calcFinalTotalEdit(this.props.item, this.props.user_data, this.props.subscription);
    let oldAmount = calcFinalTotalEdit(this.props.user_data.order_items, this.props.user_data, this.props.subscription);
    let diffAmount = Number((Number(newAmount.total) - Number(oldAmount.total)) + parseFloat(getPendingPayment(this.props.user_data) || 0))
    if (diffAmount < 0) {
      let orderData = {
        id: this.props.substitute_existing_record._id,
        paid: true,
        amount: parseFloat(diffAmount),
        type: "REFUND",
        date: Date.now()
      };
      this.props.editTransaction(orderData);
      this.callDebitMemo(diffAmount);
    } else {
      this.onClickProceed(diffAmount);
    }
  };

  onSuccessRedirect = () => {
    Alert.success(`<h4>Item updated Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    store.dispatch({
      type: CLEAR_CART_DATA,
      //payload: formData,
    });
    this.props.history.push("/orderdashboard");
  };

  onSuccessCallItemSubstitute = (memoId) => {
    const formData = { ...this.props.user_data };
    formData.order_id = this.props.user_data.order_id;
    const newFormData = { ...this.props.user_data };
    newFormData.order_items = [];
    const existingCartOrderData = this.props.cart_data.flat();
    newFormData.order_items.push(...existingCartOrderData);

    let allData = calcFinalTotalEdit(newFormData.order_items, this.props.user_data, this.props.subscription);
    formData.total_amount = allData.total;
    formData.base_amount = calcTotalOriginalEdit(newFormData.order_items);
    formData.order_items = newFormData.order_items;
    formData.gstAmount = allData?.taxes?.gst;
    formData.surCharges = allData?.taxes?.surCharges;



    delete formData.transactional_id;
    delete formData.transactionDetails;

    const token = this.props.auth.user.accessToken;
    this.props.edit_order_vendor_side_payment(
      token,
      formData,
      this.props.user_data._id,
      (newFormData.payment_method === 3 || newFormData.payment_method === 4)
        ? this.onEditDataSuccess
        : this.onSuccessPayment
    );
    this.props.substitute_items(token, formData, this.onSuccessRedirect);
  };

  onSuccessPayment = () => {
    if (![3, 4, 5].includes(this.props.user_data.payment_method)) {
      let orderData = {
        id: this.props.user_data._id,
        paid: this.props.user_data?.payment_method === 6 ? false : true,
        amount: this.state.total_amount,
        method: this.props.user_data?.payment_method === 6 ? "PAYLATER" : "EXTERNAL",
        type: this.props.user_data?.payment_method === 6 ? "PAYLATER" : "PAYMENT",
        date: Date.now(),
        paymentType: this.props.user_data?.payment_method
      };
      this.props.editTransaction(orderData, this.onEditDataSuccess);
    } else {
      this.onEditDataSuccess()
    }
  };

  onEditDataSuccess = () => {
    Alert.success(`<h4>Order Edited Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this.props.history.push("/orderdashboard");
  };

  async displayRazorpay(total, userId, name, phoneNo, email, orderId, method) {
    const res = await this.loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    const onSuccess = (data, orderId) => {
      this.setState({
        transactional_id: data.transactional._id,
        orderId: orderId,
      });
      const onSuccessHandler = (response) => {
        let orderData = {
          id: this.props.substitute_existing_record._id,
          paid: true,
          transactionId: data.transactional._id,
          txnId:data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: method
        };
        this.props.editTransaction(orderData);

        const formData = {
          razorpay_payment_id: response.razorpay_payment_id,
          transactional_id: data.transactional._id,
          order_id: this.props.substitute_existing_record._id,
          isEvent: false,
        };
        const token = this.props.auth.user.accessToken;
        this.props.razor_payment(
          token,
          formData,
          this.onSuccessCallItemSubstitute,
          orderId
        );
      };
      const onFailure = (response) => {
        let orderData = {
          id: this.props.substitute_existing_record._id,
          paid: false,
          transactionId: data.transactional._id,
          txnId:data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: method
        };
        this.props.editTransaction(orderData);
        const formData = {};
        //formData.transactional_id = data._id;
        formData.payment_status = 3;
        formData.transactional_id = data.transactional._id;
        formData.razorpay_payment_id = response.error.metadata.payment_id;
        const token = this.props.auth.user.accessToken;
        this.props.edit_order_vendor_side_payment(token, formData, orderId);
      };
      const options = {
        //key: __DEV__ ? "rzp_test_7P1z0w07gah1Uv" : "PRODUCTION_KEY",
        key: ORDER_RAZORPAY_KEY,
        currency: data.currency,
        amount: data.amount.toString(),
        order_id: data.id,
        name: "Amealio",
        description: "Amealio Ordering Payment",
        method: {
          netbanking: false,
          card: true,
          wallet: false,
          upi: false,
        },
        // config: {
        //   hide: [
        //     {
        //       method: "upi",
        //     },
        //   ],
        // },
        //image: "http://localhost:1337/logo.svg",
        handler: function (response) {
          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
          // const formData = {
          //   razorpay_payment_id: response.razorpay_payment_id,
          //   transactional_id: this.state.transactional_id,
          //   isEvent: false,
          // };
          // this.props.razor_payment(
          //   this.state.token,
          //   formData,
          //   this.onSuccessCallFinalApi
          // );
          onSuccessHandler(response);
        },
        prefill: {
          name: name,
          email: email,
          contact: phoneNo,
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      paymentObject.on("payment.failed", function (response) {
        onFailure(response);
        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
      });
    };
    const formData = {
      amount: parseFloat(total).toFixed(2),
      user_id: userId,
      refModel: "User",
      message: "Edit Item",
      currency: "INR",
      isEvent: false,
      receipt: orderId,
      orderId: orderId,
      restaurant_id: this.props.onboarding._id,
      transaction_type: "RAZORPAY",
    };
    const token = this.props.auth.user.accessToken;
    this.setState({ token: token });
    this.props.razor_pay_create_order(token, formData, onSuccess, orderId);
    // const data = await fetch("http://localhost:1337/razorpay", {
    //   method: "POST",
    // }).then((t) => t.json());
    // console.log(data);
  }

  onClickProceed = (diffAmount) => {
    const formData = this.props.user_data;
    this.setState({ total_amount: diffAmount })
    if (
      formData.payment_method === 0 ||
      formData.payment_method === 6 ||
      formData.payment_method === 9 ||
      formData.payment_method === 8
    ) {
      this.onSuccessCallItemSubstitute();
    } else {
      this.displayRazorpay(
        diffAmount,
        formData.user_id,
        formData.user_details.first_name,
        formData.user_details.mobile_number,
        formData.user_details.email,
        this.props.substitute_existing_record._id,
        formData.payment_method
      );
    }
  };

  openCreateModal = () => {
    this.setState({ open_memo_modal: !this.state.open_memo_modal });
  };
  render() {
    const { cart, payment, cart_data } = this.props;
    const { tip, open, openTract } = this.state;

    return (
      //   <React.Fragment>
      <Container fluid>
        {/* <CustomerEditModel cart={cart} payment={payment} /> */}
        {cart !== 0 && (
          <div>
            <div className="f16-700 d-flex justify-content-between">
              Customer Order Details
            </div>
            <div className="f14-500" style={{ paddingTop: "3%" }}>
              <span className="badge badge-warning p-2">
                {this.props?.substitute_existing_record &&
                  this.props?.substitute_existing_record?.order_type === 0
                  ? "Take Away"
                  : this.props?.substitute_existing_record &&
                    this.props?.substitute_existing_record?.order_type === 1
                    ? "Curb Side"
                    : this.props?.substitute_existing_record &&
                      this.props?.substitute_existing_record?.order_type === 2
                      ? "Skip the line"
                      : this.props?.substitute_existing_record &&
                        this.props?.substitute_existing_record?.order_type === 3
                        ? "Dine In"
                        : null}
              </span>
            </div>
            <div className="icons-for-border-black mobile-d-flex mt-4 mb-3">
              <div className="icons-for-border-black f12-500 mb-2 mobile-border-right mobile-f10-500 mobile-image-10px mobile-mr-3">
                <img
                  src={require("../../../../assets/images/superadmin/ordericon/1-03.svg")}
                  width="20px"
                  heigth="20px"
                  alt="Profile Pic"
                />{" "}
                &nbsp;{" "}
                {this.props?.substitute_existing_record &&
                  this.props?.substitute_existing_record?.user_details
                    .first_name}{" "}
                {this.props?.substitute_existing_record &&
                  this.props?.substitute_existing_record?.user_details
                    .last_name}
              </div>
              <div className="icons-for-border-black f12-500 mobile-border-right mobile-f10-500 mobile-image-10px mobile-mr-3">
                <img
                  src={require("../../../../assets/images/superadmin/ordericon/1-02.svg")}
                  width="20px"
                  heigth="20px"
                  alt="Code"
                />{" "}
                &nbsp;{" "}
                {this.props?.substitute_existing_record &&
                  this.props?.substitute_existing_record?.user_details
                    ?.country_code}{" "}
                {this.props?.substitute_existing_record &&
                  this.props?.substitute_existing_record?.user_details
                    ?.mobile_number}
              </div>
            </div>
            <Fragment>
              {this.props.cart_data.length > 0 ? (
                <Fragment>
                  <div style={{ paddingTop: "5%" }}>
                    <h6 className="f18-700">Memo Summary</h6>
                    <br />
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td>Original Item Value</td>
                          {/* {this.props.cart_data.length > 0 ? (
                            <td>
                              ₹
                              {this.calcSubsTotalIncludingAddon(
                                this.props.item
                              )}
                            </td>
                          ) : (
                            <> </>
                          )} */}
                          <td>
                            ₹{" "}
                            {
                              this.props?.substitute_existing_record
                                ?.editItemPrice
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>Taxes</td>
                          <td>
                            {this.props.cart_data.length > 0 ? (
                              <td>
                                ₹{" "}
                                {(parseFloat(
                                  this.calcSubstituteSurCharges(
                                    this.props.item && this.props.item[0]
                                  )
                                ) -
                                  parseFloat(
                                    Math.abs(
                                      this.calculateExitingSurCharges(
                                        this.props?.user_data &&
                                        this.props?.user_data?.order_items
                                      )
                                    )
                                  )).toFixed(2)}
                              </td>
                            ) : (
                              <>₹ 0</>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <hr />
                          </td>
                        </tr>

                        {/* <tr
                          style={{
                            backgroundColor: "#F8F8F8",
                          }}
                        >
                          {/* <td>Total</td> *
                          <td>To Be Paid</td>
                          <td>
                            {this.props.cart_data.length > 0 ? (
                              <td>
                                ₹{" "}
                                {this.calcSubstituteSurCharges(
                                  this.props.item && this.props.item[0]
                                ) -
                                  Math.abs(
                                    this.calculateExitingSurCharges(
                                      this.props?.substitute_existing_record &&
                                        this.props?.substitute_existing_record
                                          ?.order_items
                                    )
                                  ) +
                                  parseInt(
                                    this.props?.substitute_existing_record?.editItemPrice.toFixed(
                                      2
                                    )
                                  )}
                              </td>
                            ) : (
                              <>₹ 0</>
                            )}
                          </td>
                        </tr> */}

                        {getPendingPayment(this.props.user_data) && (
                          <tr>
                            <td>Pending Payment</td>
                            <td>
                              <td>
                                ₹
                                {getPendingPayment(
                                  this.props.user_data
                                ).toFixed(2)}
                              </td>
                            </td>
                          </tr>
                        )}
                        {getPendingPayment(this.props.user_data) && (
                          <tr>
                            <td colSpan={2}>
                              <hr />
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>To Be Paid</td>
                          <td>
                            {this.props.cart_data.length > 0 ? (
                              <td>₹ {this.calcFinalTotal()}</td>
                            ) : (
                              <>₹ 0</>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <CreateMemo
                    payment={payment}
                    decidePayment={this.decidePayment}
                    openCreateModal={this.openCreateModal}
                    open_memo_modal={this.state.open_memo_modal}
                  />
                  <div class="mt-3 d-flex">
                    <button
                      type="button"
                      class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                      title="Cancel Button"
                      onClick={() => this.props.history.push("/orderdashboard")}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                      title="Save Button"
                      onClick={() => { this.decidePayment(payment) }}
                    >
                      {"Proceed"}
                    </button>
                  </div>{" "}
                </Fragment>
              ) : (
                <> </>
              )}
            </Fragment>
            <hr />
          </div>
        )}
        {payment && (
          <PaymentSuccessModel
            open={open}
            props={this.props}
            setOpenTract={this.setOpenTract}
          />
        )}
        {payment && <OrderTrackEntry open={openTract} props={this.props} />}
      </Container>
      //   </React.Fragment>
    );
  }
}

const OrderTrackEntry = (props) => {
  return (
    <React.Fragment>
      <Modal show={props.open} size="md" centered>
        {/* <Modal.Header className="border-0" closeButton> */}
        {/* <Modal.Title className="f24_700_HelveticaNeue">
        Edit Customer Details
      </Modal.Title> */}
        {/* </Modal.Header> */}
        <Modal.Body>
          <h3>Order Success</h3>
          <br />
          <img
            src={require("../../../../assets/images/superadmin/ordericon/success.svg")}
            width="65px"
          />{" "}
          <br />
          <br />
          <b>Your Order has been placed successfully</b>
          <br />
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Track Button"
              onClick={() => {
                props.props.history.push("/ordertrack");
              }}
            >
              Track Order
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Okay"
              onClick={() => {
                // props.props.history.push("/ordertrack");
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const CreateMemo = (props) => {
  // const [success, setSuccess] = React.useState(false);
  return (
    <React.Fragment>
      <Modal show={props.open_memo_modal} size="md" centered>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Create Memo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f12-500 mb-2">
            Please Create the credit memo for the substituted Item
          </div>
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
              onClick={() => props.openCreateModal()}
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
              onClick={() => {
                props.openCreateModal();
                props.decidePayment(props.payment);
              }}
            >
              {"Done"}
            </button>
          </div>{" "}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const PaymentSuccessModel = (props) => {
  const [success, setSuccess] = React.useState(false);
  return (
    <React.Fragment>
      <Modal show={props.open} size="md" centered>
        {/* <Modal.Header className="border-0" closeButton> */}
        {/* <Modal.Title className="f24_700_HelveticaNeue">
            Edit Customer Details
          </Modal.Title> */}
        {/* </Modal.Header> */}
        <Modal.Body>
          <div style={{ backgroundColor: "#FFFBEE", padding: "15px" }}>
            <div className="row">
              <div className="col-6">
                Order ID: <span style={{ color: "#F85032" }}>214536878</span>
              </div>
              <div className="col-6" align="right">
                <span className="badge badge-warning">Take Away</span>
              </div>
            </div>

            <h1>Payment {success ? "Success" : "Failed"}</h1>
            <Row>
              <Col xs={2}>
                <img
                  src={require(`../../../../assets/images/superadmin/ordericon/${success ? `success` : `failed`
                    }.svg`)}
                  width="45px"
                  heigth="15px"
                />{" "}
              </Col>
              <Col xs={10} style={{ paddingTop: "10px" }}>
                {success
                  ? "Your payment has been successfully made"
                  : "Your payment has been declined"}
              </Col>
            </Row>
          </div>
          <hr />
          <div style={{ backgroundColor: "#F3F3F3", padding: "15px" }}>
            Transaction ID :{" "}
            <span style={{ color: "#F85032" }}>12467867564</span>
            <br />
            <Row>
              <Col xs={6}>
                <b>29th August 2019 </b>
                <br />
                <span style={{ color: "#757575" }}>Date</span>
              </Col>
              <Col xs={6}>
                <b>09:30 PM </b>
                <br />
                <span style={{ color: "#757575" }}>Time</span>
              </Col>
            </Row>
          </div>
          <br />
          <div style={{ backgroundColor: "#F3F3F3", padding: "15px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <b>Sub Total</b>
                  </td>
                  <td>
                    <b>₹800</b>
                  </td>
                </tr>
                <tr>
                  <td>Tip</td>
                  <td>₹20</td>
                </tr>
                <tr>
                  <td>Donation (10%)</td>
                  <td>₹20</td>
                </tr>

                <tr
                  style={{
                    backgroundColor: "#F8F8F8",
                  }}
                >
                  <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    <b>Paid</b>
                  </td>
                  <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    <b>₹895.00</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red w-100"
            title="Done"
            onClick={() => {
              props.setOpenTract();
            }}
          >
            Done
          </button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const InputPromotion = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div>
        <Paper className={classes.root}>
          <InputBase
            className={classes.input}
            placeholder="Write Here"
            inputProps={{ "aria-label": "Write Here" }}
          />
          <IconButton className={classes.iconButton} aria-label="apply">
            <button
              className="btn"
              style={{
                backgroundColor: "#2196F3",
                color: "#ffffff",
                borderRadius: "15px",
                boxShadow: "0px 5px 8px #6E6E6E57",
              }}
            >
              Apply
            </button>
          </IconButton>
        </Paper>
      </div>
    </React.Fragment>
  );
};

const tips = [
  { id: 0, title: "None" },
  { id: 1, title: "5%" },
  { id: 2, title: "10%" },
  { id: 3, title: "15%" },
  // { id: 4, title: "Custom" },
];

const donates = [
  { id: 0, title: "No" },
  { id: 1, title: "₹ 10" },
  { id: 2, title: "₹ 50" },
  { id: 3, title: "₹ 100" },
  // { id: 4, title: "Custom" },
];

const suggestions = [
  {
    id: 0,
    title: "Pepsi (250ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
  {
    id: 1,
    title: "7up (500ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
  {
    id: 2,
    title: "Pepsi (250ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
];

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  cart_data: state.vendorOrdering.vendor_cart_data,
  subscription: state.onboarding.onboard_subscription_details,
  user_data: state.vendorOrdering.vendor_order_data,
  item: state.vendorOrdering.vendor_cart_data,
  substitute_existing_record: state.vendorOrdering.get_edit_order_data,
});

export default withRouter(
  connect(mapStateToProps, {
    create_order_vedor_side,
    razor_pay_create_order,
    razor_payment,
    credit_memo_substitute_item,
    substitute_items,
    debit_memo_order_substitute_item,
    editTransaction,
    edit_order_vendor_side_payment,
  })(RightSideDetailsComponents)
);
